var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.styleMain},[_c('el-time-picker',{attrs:{"size":"small","value":_vm.display,"placeholder":"","clearable":false},on:{"input":_vm.change,"change":_vm.update}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }